import React from "react"
import { useNavigate } from "react-router-dom"
import { CareerWrapp } from "./Career.style"

const Career = () => {
  const navigate = useNavigate()

  const getQuiz = () => {
    navigate('/karir/quiz')
  }

  return (
    <CareerWrapp>
      <div className="container">
        <div className="career">
          <div className="content">
            <h1>Discover Your Ideal Career Path</h1>
            <p>Not sure which career suits you best? Take our AI-powered career assessment to find out.</p>
            <p>Get personalized recommendations for internships that match your interests and skills.</p>
            
            <div className="features">
              <div className="feature">
                <span className="icon icon-match" aria-hidden="true" />
                <h3>Personalized Matching</h3>
              </div>
              <div className="feature">
                <span className="icon icon-ai" aria-hidden="true" />
                <h3>AI-Powered Analysis</h3>
              </div>
              <div className="feature">
                <span className="icon icon-insight" aria-hidden="true" />
                <h3>Career Insights</h3>
              </div>
            </div>
            
            <button className="btn" onClick={() => getQuiz()}>Start Career Assessment</button>
            
            <p className="powered-by">
              Powered by <span>AI Technology</span>
            </p>
          </div>
        </div>
      </div>
    </CareerWrapp>
  )
}

export default Career
